import { useNonPcn } from '@stores';
import { useEffect } from 'react';
import { getEnvironmentVisibility } from '@components/environment-visibility/EnvironmentVisibility';

// Only show in local environment
const displayOutcome = getEnvironmentVisibility({ mode: 'show', local: true });

const NonPcnSuggest = ({ result }) => {
  const { setNonPcnResult, setNonPcnRequest } = useNonPcn();
  useEffect(() => {
    setNonPcnResult(result);
    setNonPcnRequest({ nonPCNResult: result });
  }, [result, setNonPcnResult, setNonPcnRequest]);

  return displayOutcome && result ? (
    <div className='margin-top-1 text-italic'>
      outcome: <div className='text-bold'>{result}</div>
    </div>
  ) : null;
};
export default NonPcnSuggest;
